import { render, staticRenderFns } from "./TheThgAnalyticsList.vue?vue&type=template&id=1abf989b&scoped=true"
import script from "./TheThgAnalyticsList.vue?vue&type=script&lang=ts"
export * from "./TheThgAnalyticsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf989b",
  null
  
)

export default component.exports